import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import DeltaArrowUp from './icon-delta-arrow-up.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <DeltaArrowUp {...validProps} />;
}
SvgComponent.iconName = 'deltaArrowUp';

export const DeltaArrowUpIcon = svgIconWrapper(SvgComponent);
